import React, { useEffect, useState } from 'react';
import { statusFlow, isFailureStatus, failurePaths } from '../utils/statusUtils';
import iphoneImage from '../assets/iphone.png'; // Ajusta la ruta según tu proyecto

const backupStatusFlow = [
  'Receiving',
  'Incoming',
  'Opening',
  'LCD Buffing',
  'Warehouse ATA',
  'Matching Kit For Assembly',
  'Phone Closing',
  'Quality Inspection',
  'Oleophobic And Overlay',
  'Packaging',
  'Finish Good'
];

const PhoneStatusCard = ({ phone, justUpdated }) => {
  const [visibleSteps, setVisibleSteps] = useState([]);
  const [currentStepIndex, setCurrentStepIndex] = useState(-1);
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    if (phone) {
      const flow = statusFlow || backupStatusFlow;
      let steps = [...flow];
      
      const failedSteps = phone.history
        .filter(h => h.result === 'fail')
        .map(h => h.status);
      
      failedSteps.forEach(failedStep => {
        const failureStep = failurePaths[failedStep];
        const index = steps.indexOf(failedStep);
        if (index !== -1 && !steps.includes(failureStep)) {
          steps.splice(index + 1, 0, failureStep);
        }
      });
      
      setVisibleSteps(steps);
      setCurrentStepIndex(steps.indexOf(phone.status));
    }
  }, [phone]);

  useEffect(() => {
    if (justUpdated) {
      setIsAnimating(true);
      const timer = setTimeout(() => setIsAnimating(false), 1000);
      return () => clearTimeout(timer);
    }
  }, [justUpdated]);

  if (!phone) return (
    <div className="bg-white p-6 rounded-lg shadow-md">
      <h2 className="text-xl font-semibold mb-4">Estado del Dispositivo</h2>
      <p className="text-gray-500">Consulta un dispositivo para ver su estado.</p>
    </div>
  );

  return (
    <div className={`bg-white p-6 rounded-lg shadow-md flex flex-col md:flex-row gap-6 transition-all duration-300 ${isAnimating ? 'ring-2 ring-green-500' : ''}`}>
      <div className="flex-1">
        <h2 className="text-xl font-semibold mb-4">Estado del Dispositivo</h2>
        <div className="mb-4">
          <p className="text-sm text-gray-500">IMEI: {phone.imei}</p>
          <p className="text-sm text-gray-500">Modelo: {phone.model} {phone.color} {phone.storage}</p>
        </div>
        <div className="space-y-1">
          {visibleSteps.map((step, index) => {
            const isCompleted = index < currentStepIndex;
            const isCurrent = index === currentStepIndex;
            const isFailure = isFailureStatus(step);
            const historyEntry = phone.history.find(h => h.status === step);
            const isMainStep = (statusFlow || backupStatusFlow).includes(step);
            const failedAtThisStep = phone.history.some(
              h => h.status === step && h.result === 'fail'
            );

            return (
              <div key={`${step}-${index}`} className="flex flex-col">
                <div className="flex items-center">
                  <div className={`w-6 h-6 rounded-full flex items-center justify-center mr-2 transition-all duration-300 ${
                    isCompleted ? 
                      (failedAtThisStep ? 'bg-red-500' : 'bg-green-500') : 
                      isCurrent ? 'bg-blue-500 animate-pulse' : 'bg-gray-200'
                  }`}>
                    {isCompleted ? (
                      failedAtThisStep ? (
                        <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                        </svg>
                      ) : (
                        <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                        </svg>
                      )
                    ) : (
                      <span className={`text-xs ${isCurrent ? 'text-white' : 'text-gray-500'}`}>
                        {index + 1}
                      </span>
                    )}
                  </div>
                  <span className={`transition-all duration-300 ${
                    isCompleted ? 
                      (failedAtThisStep ? 'text-red-600 font-medium' : 'text-green-600 font-medium') : 
                      isCurrent ? 'text-blue-600 font-bold' : 'text-gray-500'
                  } ${isMainStep ? '' : 'ml-8 text-sm'}`}>
                    {step}
                  </span>
                  {isCompleted && historyEntry && (
                    <span className={`ml-2 text-xs ${failedAtThisStep ? 'text-red-500' : 'text-green-500'}`}>
                      {new Date(historyEntry.timestamp)?.toLocaleTimeString()}
                    </span>
                  )}
                </div>
                {failedAtThisStep && failurePaths[step] && (
                  <div className="flex items-center ml-8 mt-1">
                    <div className="w-4 h-4 rounded-full flex items-center justify-center mr-2 bg-red-500">
                      <svg className="w-3 h-3 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                      </svg>
                    </div>
                    <span className="text-sm text-red-600 font-medium">
                      {failurePaths[step]}
                    </span>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>

      <div className="w-80 md:w-70 flex-shrink-0">
        <img src={iphoneImage} alt="iPhone" className="w-full h-auto object-contain opacity-90" />
      </div>
    </div>
  );
};

export default PhoneStatusCard;
